import Modal from 'react-modal';
import './ChangePassword.css';
import React, {useEffect, useState} from "react";
import InputPin from "../../../InputPin/InputPin";
import axios from "axios";
import {Navigate} from "react-router-dom";

const ChangePassword = ({isOpen, onRequestClose}) => {

    const [codeVerified, setCodeVerified] = useState(false);
    const [phoneChanged, setPhoneChanged] = useState(false);
    const [codeInput, setCodeInput] = useState(null);
    const [changeError, setChangeError] = useState(null);

    const [email, setEmail] = useState(null);

    const [isFirstPasswordVisible, setIsFirstPasswordVisible] = useState(false);
    const [isSecondPasswordVisible, setIsSecondPasswordVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            axios.get(`/api/forgot_password_request_code/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    // 'X-CSRFToken': getCookie('csrftoken'),
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true
            })
                .then(res => {
                    console.log(res.data.detail);
                    setCodeInput(res.data.detail);
                })
                .catch(e => {
                    console.log(e);
                })
        }
    }, [setCodeInput, isOpen]);

    useEffect(() => {
        axios.get(`/api/give_email/`, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true
        })
            .then(res => {
                setEmail(res.data.detail);
            })
            .catch(e => {
                console.log(e);
            })
    })

    const closeAccept = () => {
        onRequestClose(false);
        setCodeVerified(false);
        // document.getElementById('change-pass1').value = '';
        // document.getElementById('change-pass2').value = '';
    }

    const verifyCode = () => {
        let data = {};
        data['code'] = codeInput;

        axios.post(`/api/verify_code/`, data, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log(res);
                setCodeVerified(true);
                setChangeError(null);
            })
            .catch(e => {
                console.log('Код неверный');
                if (e.status === 403) {
                    setChangeError('Неверный или истекший код подтверждения');
                }
                else {
                    setChangeError('Ошибка');
                }
            })
    }

    const newPassword = () => {
        let data = {};
        data['password1'] = document.getElementById('change-pass1').value;
        data['password2'] = document.getElementById('change-pass2').value;

        axios.post(`/api/change_password/`, data, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log(res);
                setPhoneChanged(true);
                setChangeError('Пароль успешно изменён');
                closeAccept();
            })
            .catch(e => {
                console.log(e);
                if (e.status === 400) {
                    setChangeError('Новые пароли не совпадают или не соответствуют требованиям');
                }
                else if (e.status === 403) {
                    setChangeError('Истек срок действия кода подтверждения');
                }
                else if (e.status === 422) {
                    setChangeError('Пароль не может быть нулевым');
                }
                else if (e.status === 423) {
                    setChangeError('Новые пароли не совпадают');
                }
                else if (e.status === 424) {
                    setChangeError('Минимум 8 символов, включая одну строчную, заглавную буквы, одну цифру, спец. символ');
                }
                else {
                    setChangeError('Ошибка');
                }
            })
    }

    const togglePasswordVisibility = (num) => {
        if (num === 1) {
            setIsFirstPasswordVisible((prev) => !prev);
        }
        else if (num === 2) {
            setIsSecondPasswordVisible((prev) => !prev);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            // onRequestClose={closeAccept}
            contentLabel="Смена пароля"
            className="change-pwd-modal"
            overlayClassName="modal-overlay-change-pwd"
            appElement={document.getElementById('root')}
        >
            <div className="restore-pwd">
                <div className={'close-restore-modal-btn-container'}>
                    <button className={'close-restore-modal'} onClick={closeAccept}>X</button>
                </div>

                {!codeVerified && (
                    <div className={'restore-pwd-modal-container-code'}>
                        <p className={'restore-pwd-text'}>Код отправлен на почту {email}</p>

                        <InputPin serverCode={codeInput} setCode={setCodeInput}/>

                        <div className={`change-error-block`}>{changeError !== null ? changeError : ''}</div>
                        <button className={'restore-pwd-accept'} onClick={() => verifyCode()}>Сменить!</button>
                    </div>
                )}
                {codeVerified && (
                    <div className={'restore-pwd-modal-container-pwd'}>

                        <div className={'restore-pwd-inputs-container'}>
                            <div className={'restore-form-input'}>
                                <div className={'password-restore'}>
                                    <input
                                        type={isFirstPasswordVisible ? 'text' : 'password'}
                                        id={'change-pass1'}
                                        className={'restore-pwd-input'}
                                        placeholder={'Новый пароль:'}
                                        required
                                    />
                                    <a
                                        href="#"
                                        className={`password-control-restore ${isFirstPasswordVisible ? 'view' : ''}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            togglePasswordVisibility(1);
                                        }}
                                    />
                                </div>
                            </div>

                            <div className={'restore-pwd-2-and-error'}>
                                <div className={'restore-form-input'}>
                                    <div className={'password-restore'}>
                                        <input
                                            type={isSecondPasswordVisible ? 'text' : 'password'}
                                            id={'change-pass2'}
                                            className={'restore-pwd-input'}
                                            placeholder={'Повтор пароля:'}
                                            required
                                        />
                                        <a
                                            href="#"
                                            className={`password-control-restore ${isSecondPasswordVisible ? 'view' : ''}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                togglePasswordVisibility(2);
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className={`change-error-block ${phoneChanged ? 'change-success' : ''}`}>{changeError!==null ? changeError : ''}</div>
                            </div>
                        </div>

                        <button className={'restore-pwd-accept-pwd'} onClick={() => newPassword()}>Подтвердить!</button>

                    </div>
                )}
            </div>
        </Modal>
    );
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default ChangePassword;